import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

// @material-ui/core components
import Collapse from '@material-ui/core/Collapse';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

// core components
import Status from './Status';
import ActionBooking from './ActionBooking';
import Booking from './booking';

const useStyles = makeStyles(theme => ({
  lessIcon: {
    color: theme.palette.secondary.main,
  },
}));

function RowBooking({ showStatus, showOptions, row, index }) {
  const classes = useStyles();
  const loggedUser = JSON.parse(localStorage.currentUser);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [handleAction, setHandleAction] = useState(false);

  const handleClick = (event, index) => {
    if (selectedIndex === index) {
      setSelectedIndex(null);
    } else {
      setSelectedIndex(index);
    }
  };

  const handleClose = () => setSelectedIndex(null)

  return (
    <>
      <TableRow
        key={row.id}
        hover
        style={{ cursor: 'pointer' }}
      >
        <TableCell padding="checkbox" onClick={event => handleClick(event, index)}>
          { selectedIndex === index ? (
              <ExpandLessIcon className={classes.lessIcon}/>
            ) : (
              <ExpandMoreIcon />
          ) }
        </TableCell>
        <TableCell align="center" onClick={event => handleClick(event, index)}>{row.id}</TableCell>
        <TableCell align="center" onClick={event => handleClick(event, index)}>{row.user.full_name}</TableCell>
        <TableCell align="center" onClick={event => handleClick(event, index)}>
          {new Date(row.departure_datetime).toLocaleString('es-CR', { hour12: true })}
        </TableCell>
        <TableCell align="center" onClick={event => handleClick(event, index)}>
          {row.return_datetime
            ? new Date(row.return_datetime).toLocaleString('es-CR', { hour12: true })
            : '--'}
        </TableCell>
        {showStatus && (
          <TableCell align="center" onClick={event => handleClick(event, index)}>
            <Status value={row.status} />
          </TableCell>
        )}
        {showOptions && (
          <TableCell align="center">
            <ActionBooking
              status={row.status}
              role={loggedUser.role}
              bookingId={row.id}
              userId={row.user.id}
              isOwner={row.user.id === loggedUser.id}
              driverId={row.service && row.service.driver_id}
              onAction={setHandleAction}
              rate={{ratingValue: parseFloat(row.rating_value), ratingComment: row.rating_comment}}
            />
          </TableCell>
        )}
      </TableRow>
      <TableRow>
        <TableCell style={{ padding: 0 }} colSpan={12}>
          <Collapse
            in={!handleAction && selectedIndex === index}
            timeout="auto"
            unmountOnExit
            // hidden={!isSelected}
          >
            <Booking booking={row} onClose={handleClose} />
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

export default RowBooking;
